import { action, atom } from '@reatom/framework'

export const SettingScreenPolicies = [
  'terms-of-service',
  'privacy-policy',
  'anti-money-laundering-policy',
  'boosting-terms',
  'disclaimer-terms',
  'affiliate-program-terms',
  'live-streaming-terms',
  'token-creation-and-promotion-terms',
  'legal-entity-access-terms',
] as const
export type SettingScreenPolicy = (typeof SettingScreenPolicies)[number]

export type SettingScreen =
  | 'main'
  | 'shortcuts'
  | 'sessions'
  | 'security'
  | 'language'
  | 'setup-otp'
  | 'update-password'
  | 'update-local-password'
  | 'app-settings'
  | 'trading-mode'
  | 'app-settings-theme'
  | 'app-settings-custom-theme'
  | 'policies'
  | 'account-and-privacy'
  | SettingScreenPolicy
export type SettingScreenMode =
  | 'single-policy-screen'
  | 'settings-with-navigation'

export const settingScreenAtom = atom<SettingScreen | undefined>(
  undefined,
  'settingScreenAtom',
)
export const settingScreenModeAtom = atom<SettingScreenMode | undefined>(
  undefined,
  'settingScreenModeAtom',
)

export const settingScreenAction = action((ctx, screen: SettingScreen) => {
  settingScreenAtom(ctx, screen)
  settingScreenModeAtom(ctx, 'settings-with-navigation')
}, 'settingScreenAction')

export const policyScreenAction = action((ctx, screen: SettingScreenPolicy) => {
  settingScreenAtom(ctx, screen)
  settingScreenModeAtom(ctx, 'single-policy-screen')
}, 'policyScreenAction')

export const telegramUnassignOpenAtom = atom<boolean>(
  false,
  'telegramUnassignOpenAtom',
)
export const googleUnassignOpenAtom = atom<boolean>(
  false,
  'googleUnassignOpenAtom',
)
